<form [formGroup]="resetPasswordForm" novalidate (ngSubmit)="onSubmit()">
    <mat-card class="reset-password-card">
        <h4>Enter your email</h4>
        <mat-card-content>
            <div class="row">
                <div class="col">
                    <mat-form-field class="full-width">
                        <input matInput type="email" placeholder="Email" formControlName="email" required />
                        <mat-error *ngIf="isEmailNotValid()">
                            {{ getEmailErrorMessage() }}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </mat-card-content>
        <mat-card-actions>
            <button class="full-width" [disabled]="this.sendingInProgress" mat-raised-button color="primary" type="submit">{{this.sendingInProgress ? 'Sending':'Reset password'}}</button>
        </mat-card-actions>
    </mat-card>
</form>
